import { render, staticRenderFns } from "./ProductoSelectComponentV2.vue?vue&type=template&id=17caf45f&"
import script from "./ProductoSelectComponentV2.vue?vue&type=script&lang=js&"
export * from "./ProductoSelectComponentV2.vue?vue&type=script&lang=js&"
import style0 from "./ProductoSelectComponentV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports